import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import {
  BILLING_PREFIX,
  BILLING_PROXY_EDIT,
  BILLING_PROXY_VIEW,
} from '../config';
import { assignStudioQuery } from '.';
import {
  IAPIAddInvoiceBody,
  IAPIApplyInvoiceItem,
  IAPICanOpenInvoiceBillItem,
  IAPICreateUpdateInvoiceInfo,
  IAPIFeeCenterMailManageItem,
  IAPIInvoiceHeader,
  IAPIInvoiceHistoryItem,
} from '../../model/api-modules/bill-center/invoice';

export const modifyInvoiceEmailList = (data: IAPIAddInvoiceBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PREFIX}/mail-manage`);
      await api.commonRequest('POST', url, data);
      return true;
    } catch (error) {
      console.log('failed: modifyInvoiceEmailList', error);
      return false;
    }
  });

export const getInvoiceEmailList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PREFIX}/mail-manage/${studioId}`
      );
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<
        ReadonlyArray<IAPIFeeCenterMailManageItem>
      >(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getInvoiceEmailList', error);
      return [];
    }
  });

export const getInvoiceHeaderList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PROXY_VIEW}/api/invoice/list`);
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        page: 1,
        size: 1000,
      });
      const res = await parsedResponse<{
        list: ReadonlyArray<IAPIInvoiceHeader>;
      }>(response, 'data');
      return res.list[0];
    } catch (error) {
      console.log('failed: getInvoiceHeaderList', error);
      return;
    }
  });

export const createUpdateInvoiceHeaderList = (
  data: IAPICreateUpdateInvoiceInfo
) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PROXY_EDIT}/api/invoice/create`);
      const response = await api.commonRequest('POST', url, data);
      const res = await parsedResponse<string>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getInvoiceHeaderList', error);
      return false;
    }
  });

export const deleteInvoiceHeaderList = (id: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${BILLING_PROXY_EDIT}/api/invoice/remove`);
      await api.commonRequest('POST', url, { invoice_id: id });
      return true;
    } catch (error) {
      console.log('failed: getInvoiceHeaderList', error);
      return false;
    }
  });

export const getCanOpenInvoiceBillList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/invoice/can_open_list`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        page: 1,
        size: 1000,
      });
      const res = await parsedResponse<{
        list: ReadonlyArray<IAPICanOpenInvoiceBillItem>;
      }>(response, 'data');
      return res.list;
    } catch (error) {
      console.log('failed: getInvoiceHeaderList', error);
      return [];
    }
  });

export const applyInvoice = (data: IAPIApplyInvoiceItem) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_EDIT}/api/invoice/apply_invoice`
      );
      const response = await api.commonRequest('POST', url, data);
      const res = await parsedResponse<string>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getInvoiceHeaderList', error);
      return;
    }
  });

export const getInvoiceHistory = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/invoice/invoice_order_list`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        page: 1,
        size: 1000,
      });
      const res = await parsedResponse<{
        list: ReadonlyArray<IAPIInvoiceHistoryItem>;
      }>(response, 'data');
      return res.list;
    } catch (error) {
      console.log('failed: getInvoiceHeaderList', error);
      return [];
    }
  });

export const downloadInvoice = (ids?: string[]) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${BILLING_PROXY_VIEW}/api/invoice/download_invoice`
      );
      const response = await api.blobCommonRequest('GET', url, {
        apply_ids: ids?.join(),
      });
      return response;
    } catch (error) {
      console.log('failed: getInvoiceHeaderList', error);
      return;
    }
  });
